import "./App.css";
import React from "react";
import { useFormik } from "formik";
import appvalidate, {
  appvalidateRedemption,
} from "./validations/app.validation";
import OnboardService from "./services/services";
import { useSnackbar } from "notistack";
import { isMobile } from "react-device-detect";
import InitialPage from "./Desktop/Components/initialPage";
import SuccessPage from "./Desktop/Components/successPage";
import InitialPageMobile from "./Mobile/Components/initialPage";
import SuccessPageMobile from "./Mobile/Components/successPage";
import InitialPageAppsumo from "./Appsumo_Desktop/Components/initialPage";

import InitialPageAppsumoMobile from "./Appsumo_Mobile/Components/initialPage";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

function App() {

  const {
    REACT_APP_POST_URL: postUrl,
    REACT_APP_CHAT_BOT: chatUrl,
    REACT_APP_TENANT_DOMAIN: tenantDomain,
    REACT_APP_DOMAIN_URL: domainURL,
    REACT_APP_POST_TEMP_TENANT_URL: tempTenantURL,
  } = process.env;
  const { enqueueSnackbar } = useSnackbar();
  const urlSearchParams = new URLSearchParams(window.location.search);
  var url = window.location.href;
  const [showPassword, setshowPassword] = React.useState(false);
  const params = Object.fromEntries(urlSearchParams.entries());

  var format = /[^\w-]/;
  let data = {
    companyName: "",
    tenantCode: "",
    email: "",
    userName: "",
    password: "",
    IsDemoRequired: false,
    redemption: "",
    UTMID: "",
    UTMCampaign: "",
  };


  const [loadingcondition, setloadingcondition] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, seterror] = React.useState(false);
  const [tenantCodeAvailable, setTenantCodeAvailable] = React.useState(false);
  const [redemptionCodeAvailable, setRedemptionCodeAvailable] =
    React.useState(false);
  const [emailAvailable, setEmailAvailable] = React.useState(false);
  // const [crmID, setCrmID] = React.useState(0);

  async function checkEmailAvailability(email) {
    try {
      const resEmail = await fetch(`${domainURL}/isTenantsEmailMapped`, {
        method: "POST",
        body: JSON.stringify({
          email: email,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "x-tenant": "checkemail"
        },
      }).then((response) => response.json());
      if (
        resEmail.message ===
        "TD005: Already company registerd with this EMAIL ID"
      ) {
        setEmailAvailable(true);
      } else {
        setEmailAvailable(false);
      }
      return resEmail.message;
    } catch (err) {
      seterror(true);
      enqueueSnackbar(`Something went wrong ${err}`, {
        variant: "error",
        autoHideDuration: 5000,
      });
    }
  }

  async function checkTenantAvailability(tenantCOde) {
    try {
      if (!format.test(tenantCOde)) {
        const res = await fetch(
          `${domainURL}/isTenantCodeAvailable?tenantCode=${tenantCOde}`
        ).then((response) => response.json());
        if (res.message === "TD005: Already TenantCode Exist") {
          setTenantCodeAvailable(true);
        } else {
          setTenantCodeAvailable(false);
        }
      } else {
        setTenantCodeAvailable(false);
      }
    } catch (err) {
      seterror(true);
      enqueueSnackbar(`Something went wrong ${err}`, {
        variant: "error",
      });
    }
  }

  async function checkRedeemAvailability() {
    try {
      let redemption = Formdata.values.redemption;
      if (!format.test(redemption) && redemption !=="") {
        const res = await fetch(
          `${domainURL}/getRedemptionCodes?code=${redemption}`
        ).then((response) => response.json());
        if (res.message === "InValid code") {
          setRedemptionCodeAvailable(true);
        } else {
          setRedemptionCodeAvailable(false);
        }
      } else {
        setRedemptionCodeAvailable(false);
      }
    } catch (err) {
      seterror(true);
      enqueueSnackbar(`Something went wrong ${err}`, {
        variant: "error",
      });
    }
  }

  async function submit() {
    try {
      setLoading(true);
      await checkTenantAvailability(Formdata.values.tenantCode);
      await checkRedeemAvailability();
      if(redemptionCodeAvailable){
        return
      }
      
      if (
        !format.test(Formdata.values.tenantCode) &&
        Formdata.isValid &&
        !tenantCodeAvailable &&
        !emailAvailable &&
        !redemptionCodeAvailable
      ) {
        setloadingcondition(true);
        let initialData = {
          tenantCode: Formdata.values.tenantCode.toLowerCase(),
          tenantDescription: Formdata.values.tenantCode.toLowerCase(),
          tenantDomain: `${Formdata.values.tenantCode.toLowerCase()}.${tenantDomain}`,
          companyName: Formdata.values.companyName,
          userName: Formdata.values.userName,
          companyEmail: Formdata.values.email.toLowerCase(),
          accountTypeID: 1,
          password: Formdata.values.password,
          isDemoRequired: Formdata.values.IsDemoRequired ? 1 : 0,
          redemptionCode: Formdata.values.redemption,
          uTMID: params ? (params.utm_id ? params.utm_id : null) : null,
          uTMCampaign: params
            ? params.utm_campaign
              ? params.utm_campaign
              : null
            : null,
            planId: params ? (params.utm_id ? params.utm_id : null) : null,
        };
        const responseSuccess = await OnboardService.postInitialData(
          postUrl,
          initialData,
          Formdata.values.tenantCode
        );
        let chatbody = {
          cards: [
            {
              header: {
                title: "Tenant onboard",
                subtitle: "New tenant",
                imageUrl:
                  "https://dev-bcommerce-assets.s3.ap-northeast-1.amazonaws.com/app_assets/company_images/1/header/dark_logo/Growmax%20PWA%20Icon%20500x500_1624707667374.png",
              },
              sections: [
                {
                  widgets: [
                    {
                      keyValue: {
                        topLabel: "Tenant Code",
                        content: Formdata.values.tenantCode.toLowerCase(),
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Email",
                        content: Formdata.values.email.toLowerCase(),
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Company Name",
                        content: Formdata.values.companyName,
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Customer Name",
                        content: Formdata.values.userName,
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Demo",
                        content: Formdata.values.IsDemoRequired
                          ? "Required"
                          : "Not Required",
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Cusomer Category",
                        content: url.includes("appsumo")
                          ? `From Appsumo with code ${Formdata.values.redemption}`
                          : `Direct Customer with code ${Formdata.values.redemption}`,
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "uTMID",
                        content: params
                          ? params.utm_id
                            ? params.utm_id
                            : "NA"
                          : "NA",
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "uTMCampaign",
                        content: params
                          ? params.utm_campaign
                            ? params.utm_campaign
                            : "NA"
                          : "NA",
                      },
                    },
                    {
                      keyValue: {
                        topLabel: "Error Code",
                        content: responseSuccess.status,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        };
  
        if(responseSuccess.status === "fail" && responseSuccess.message=== "Invalid Plan Id") {
          let invalidPlanChatbody = {
            cards: [
              {
                header: {
                  title: "Tenant onboard",
                  subtitle: "New tenant",
                  imageUrl:
                    "https://dev-bcommerce-assets.s3.ap-northeast-1.amazonaws.com/app_assets/company_images/1/header/dark_logo/Growmax%20PWA%20Icon%20500x500_1624707667374.png",
                },
                sections: [
                  {
                    widgets: [
                      {
                        keyValue: {
                          topLabel: "Tenant Code",
                          content: Formdata.values.tenantCode.toLowerCase(),
                        },
                      },
                      {
                        keyValue: {
                          topLabel: "Email",
                          content: Formdata.values.email.toLowerCase(),
                        },
                      },
                      {
                        keyValue: {
                          topLabel: "Company Name",
                          content: Formdata.values.companyName,
                        },
                      },
                      {
                        keyValue: {
                          topLabel: "Customer Name",
                          content: Formdata.values.userName,
                        },
                      },
                      {
                        keyValue: {
                          topLabel: "Action",
                          content: "Tried with invalid plan",
                        },
                      },
                      
                     
                    ],
                  },
                ],
              },
            ],
          };
          await fetch(
            chatUrl,
            {
              method: "POST",
              mode: "no-cors",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(invalidPlanChatbody),
            }
          );
          
          setloadingcondition(false);
          seterror(true);
          enqueueSnackbar(`Invalid Plan ID`, {
            variant: "error",
          });
          setLoading(false);
        } else if (responseSuccess.status === "success") {
          await fetch(
            chatUrl,
            {
              method: "POST",
              mode: "no-cors",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(chatbody),
            }
          );
          setloadingcondition(false);
          seterror(false);
          window.location.replace("/get-started/success");
        } else {
          await OnboardService.postchatbot(chatUrl, chatbody);
          setloadingcondition(false);
          seterror(true);
          enqueueSnackbar(`Something went wrong`, {
            variant: "error",
          });
        }
      } else {
        if (
          redemptionCodeAvailable &&
          tenantCodeAvailable &&
          emailAvailable &&
          !format.test(Formdata.values.tenantCode)
        ) {
          enqueueSnackbar(`Please enter valid data in email and domain name`, {
            variant: "error",
            preventDuplicate: true,
          });
        } else if (tenantCodeAvailable) {
          enqueueSnackbar(`Domain name not available`, {
            variant: "error",
            preventDuplicate: true,
          });
        } else if (emailAvailable) {
          enqueueSnackbar(`Email already registered with us`, {
            variant: "error",
            preventDuplicate: true,
          });
        } else if (redemptionCodeAvailable) {
          enqueueSnackbar(`Redemption code is invalid`, {
            variant: "error",
            preventDuplicate: true,
          });
        } else {
          enqueueSnackbar(`Special characters not allowed in domain name`, {
            variant: "error",
            preventDuplicate: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      seterror(true);
      enqueueSnackbar(`Something went wrong ${err}`, {
        variant: "error",
        preventDuplicate: true,
      });
    } finally {
     if (!format.test(Formdata.values.tenantCode) && Formdata.isValid) {
        Formdata.isSubmitting(false);
        setLoading(false);
      }
    }
  }

  async function updateTempData() {
    try {
      const dataTemp = await OnboardService.postTempData(tempTenantURL, {
        id: null,
        email: Formdata.values.email,
        password: ""
      })

      // if (dataTemp) {
      //   setCrmID(dataTemp.data);
      // }
      return dataTemp;
    } catch (err) {
      console.log(err);
    }
  }

  const Formdata = useFormik({
    initialValues: data,
    validateOnChange: true,
    enableReinitialize: true,
    validationSchema: window.location.pathname.includes("appsumo")
      ? appvalidateRedemption
      : appvalidate,
    onSubmit: submit,
  });

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to="/get-started" />
        </Route>
        <Route path="/get-started/appsumo">
          {isMobile ? (
            <Router>
              <Route exact path="/get-started/appsumo">
                <InitialPageAppsumoMobile
                  Formdata={Formdata}
                  checkTenantAvailability={checkTenantAvailability}
                  checkEmailAvailability={checkEmailAvailability}
                  checkRedeemAvailability={checkRedeemAvailability}
                  showPassword={showPassword}
                  setshowPassword={setshowPassword}
                  submit={submit}
                  emailAvailable={emailAvailable}
                  setTenantCodeAvailable={setTenantCodeAvailable}
                  redemptionCodeAvailable={redemptionCodeAvailable}
                  setRedemptionCodeAvailable={setRedemptionCodeAvailable}
                  setEmailAvailable={setEmailAvailable}
                  tenantCodeAvailable={tenantCodeAvailable}
                  loadingcondition={loadingcondition}
                  updateTempData={updateTempData}
                  loading={loading}
                  setLoading={setLoading}
                />
              </Route>
              <Route exact path="/get-started/success">
                <SuccessPage
                  loadingcondition={loadingcondition}
                  error={error}
                  tenantCode={Formdata.values.tenantCode}
                />
              </Route>
            </Router>
          ) : (
            <Router>
              <Route exact path="/get-started/appsumo">
                <InitialPageAppsumo
                  Formdata={Formdata}
                  checkTenantAvailability={checkTenantAvailability}
                  checkEmailAvailability={checkEmailAvailability}
                  checkRedeemAvailability={checkRedeemAvailability}
                  showPassword={showPassword}
                  setshowPassword={setshowPassword}
                  submit={submit}
                  emailAvailable={emailAvailable}
                  setTenantCodeAvailable={setTenantCodeAvailable}
                  redemptionCodeAvailable={redemptionCodeAvailable}
                  setRedemptionCodeAvailable={setRedemptionCodeAvailable}
                  setEmailAvailable={setEmailAvailable}
                  tenantCodeAvailable={tenantCodeAvailable}
                  loadingcondition={loadingcondition}
                  updateTempData={updateTempData}
                  loading={loading}
                  setLoading={setLoading}
                />
              </Route>
              <Route exact path="/get-started/success">
                <SuccessPage
                  loadingcondition={loadingcondition}
                  error={error}
                  tenantCode={Formdata.values.tenantCode}
                />
              </Route>
            </Router>
          )}
        </Route>
        <Route path="/get-started">
          {isMobile ? (
            <Router>
              <Route exact path="/get-started">
                <InitialPageMobile
                  Formdata={Formdata}
                  checkTenantAvailability={checkTenantAvailability}
                  checkEmailAvailability={checkEmailAvailability}
                  showPassword={showPassword}
                  setshowPassword={setshowPassword}
                  submit={submit}
                  emailAvailable={emailAvailable}
                  setTenantCodeAvailable={setTenantCodeAvailable}
                  setEmailAvailable={setEmailAvailable}
                  tenantCodeAvailable={tenantCodeAvailable}
                  loadingcondition={loadingcondition}
                  updateTempData={updateTempData}
                  loading={loading}
                  setLoading={setLoading}
                />

              </Route>

              <Route exact path="/get-started/success">
                <SuccessPageMobile
                  loadingcondition={loadingcondition}
                  error={error}
                  tenantCode={Formdata.values.tenantCode}
                />
              </Route>
            </Router>
          ) : (
            <Router>
              <Route exact path="/get-started">
                <InitialPage
                  Formdata={Formdata}
                  checkTenantAvailability={checkTenantAvailability}
                  checkEmailAvailability={checkEmailAvailability}
                  showPassword={showPassword}
                  setshowPassword={setshowPassword}
                  submit={submit}
                  emailAvailable={emailAvailable}
                  setTenantCodeAvailable={setTenantCodeAvailable}
                  setEmailAvailable={setEmailAvailable}
                  tenantCodeAvailable={tenantCodeAvailable}
                  loadingcondition={loadingcondition}
                  updateTempData={updateTempData}
                  loading={loading}
                  setLoading={setLoading}
                />
              </Route>
              <Route exact path="/get-started/success">
                <SuccessPage
                  loadingcondition={loadingcondition}
                  error={error}
                  tenantCode={Formdata.values.tenantCode}
                />
              </Route>
            </Router>
          )}
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
